import React from 'react'

export default function Enquiries() {
  return (
    <div>
      
    </div>
  )
}
